import { logger } from '@gem/modules/logger';

import { getCommitMessages } from 'APP/Tasks/e2ee/getCommitMessages';
import { mapIE2eeMessagePayload } from 'APP/model/e2ee/e2eeModel.mapper';
import { E2eePayloadType } from 'APP/model/e2ee/e2eeModel.types';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

interface ICheckEpochAndDecodePayloadData {
  groupId: string;
  e2eeData: ArrayBuffer;
  epoch: number;
  callback(decodedText: string): void;
}
export const checkEpochAndDecodePayload = async ({
  groupId,
  e2eeData,
  epoch,
  callback,
}: ICheckEpochAndDecodePayloadData): Promise<void> => {
  try {
    const mlsGroup = MlsStorageService.loadGroup(groupId);

    if (!mlsGroup) {
      return;
    }

    const groupEpoch = mlsGroup.currentEpoch();

    if (epoch > Number(groupEpoch)) {
      await getCommitMessages(groupId, Number(groupEpoch));
    }

    const decodedArrayBuffer = MlsStorageService.parseMessage(e2eeData, groupId);

    if (!decodedArrayBuffer) {
      return;
    }
    const decodedPayload = mapIE2eeMessagePayload(decodedArrayBuffer);

    // ToDo: [E2EE]: после появленя новых пайлоадов реализовать либо
    //  новые классы пайлоадов, либо расширить E2ee пайлоад новыми сабклассами
    switch (decodedPayload.payloadType) {
      case E2eePayloadType.RichText: {
        callback(decodedPayload.text);
      }
    }
  } catch (error) {
    logger.get('Tasks').error('e2ee.checkEpochAndDecodePayload', error);
  }
};
